import n from "./index446.js";
import { createBlock as r, openBlock as e, resolveDynamicComponent as t } from "vue";
import p from "./index231.js";
function s(o, c, i, a, m, f) {
  return e(), r(t("script"), {
    type: "application/ld+json",
    innerHTML: o.jsonLdString
  }, null, 8, ["innerHTML"]);
}
const u = /* @__PURE__ */ p(n, [["render", s]]);
export {
  u as default
};
